import { render, staticRenderFns } from "./RedirectionHandlerPage.vue?vue&type=template&id=3482e95c"
import script from "./RedirectionHandlerPage.vue?vue&type=script&lang=ts"
export * from "./RedirectionHandlerPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports